var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"br flex justify-between mb-2"},[_c('span',{staticClass:"font-bold uppercase"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"flex items-center gap-2"},[_vm._v(" "+_vm._s(_vm.value)+" "),_vm._t("button")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }